import type { Card } from '../../types';

export const BULWARK: Card = {
  id: 'bulwark',
  name: 'Bulwark',
  type: 'defense',
  rarity: 'rare',
  size: { w: 2, h: 2 },
  // ADR-0015 §19 nudge: min:4,4 → min:5,5. Card identity preserved (stack ≥X
  // dice for a wall) but it lands less reliably turn-on-turn, so Power Strike's
  // new scaling can break the Tower Guard stalemate.
  cost: [
    { kind: 'min', value: 5 },
    { kind: 'min', value: 5 },
  ],
  effects: [{ kind: 'block', amount: 10 }],
};
